import AspenZone from "@aspen/Aspen/AspenZone";
import InitOpenClose, { initMobileFooterNavOpenClose } from "@aspen/Aspen/InitOpenClose";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            img {
                height: 78px;
            }
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://code.jquery.com/jquery-3.7.0.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
          document.body.removeChild(script);
        };
      }, []);
    useEffect(() => {
        let isOpenCloseInitiated = false;
        const interval = setInterval(() => {
            if (typeof window === 'object' && typeof document === 'object' && window.jQuery!==undefined && !isOpenCloseInitiated) {
                isOpenCloseInitiated=InitOpenClose();
                initMobileFooterNavOpenClose();
                clearInterval(interval);
            }
        }, 300);
    }, []);

    return (
        <div className="as-footer">
            <div className="as-container">
                <div className="as-footer-nav-wrap">
                    <AspenZone zoneName="FooterNavOne" contentId={id} hideWrapper={true} />
                    <AspenZone zoneName="FooterNavTwo" contentId={id} hideWrapper={true} />
                    <AspenZone zoneName="Contact" contentId={id} hideWrapper={true} />
                    <div className="as-footer-area">
                        <AspenZone zoneName="Logo" contentId={id} tagNameAs="div" className="as-logo-footer" />
                        <AspenZone zoneName="RequestProductSamples" contentId={id} hideWrapper={true}></AspenZone>
                        <AspenZone zoneName="SocialNetworks" contentId={id} hideWrapper={true} />
                    </div>
                </div>
                <AspenZone zoneName="Copyright" className="as-copy" tagNameAs="div" contentId={id} />
            </div>
        </div>

    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
